declare const Stripe: any;
import d from "./DOM.js";
import { withCsrf } from "./csrf.js";

export default class Pricing {
	private static prices: { 
		monthly: { pro: string, proPlus: string }, 
		annual: { pro: string, proPlus: string } 
	} | null = null;
	private static billingInterval: 'monthly' | 'annual' = 'monthly';
	
	public static async init() {
		await Pricing.loadPrices();
		d.e('click', Pricing.handleUpgrade, d.qsa('.upgrade-btn'));
		
		// Toggle Logic
		const toggle = d.get<HTMLInputElement>('billing-toggle');
		
		if (toggle) {
			d.e('change', () => {
				Pricing.billingInterval = toggle.checked ? 'annual' : 'monthly';
				Pricing.updateUI();
			}, toggle);
		}
	}
	
	private static updateUI() {
		const isAnnual = Pricing.billingInterval === 'annual';
		
		// Update Prices
		const proPrice = d.get<HTMLElement>('price-pro');
		const proPlusPrice = d.get<HTMLElement>('price-pro-plus');
		const periodLabels = d.qsa<HTMLElement>('.billing-period');
		
		if (proPrice) { proPrice.textContent = isAnnual ? '$290' : '$29'; }
		if (proPlusPrice) { proPlusPrice.textContent = isAnnual ? '$790' : '$79'; }
		
		periodLabels.forEach(el => { el.textContent = isAnnual ? '/yr' : '/mo'; });
	}
	
	private static async loadPrices() {
		try {
			const res = await fetch('/api/subscription/prices');
			Pricing.prices = await res.json();
		} catch (err) {
			console.error('Failed to load prices', err);
		}
	}
	
	private static async handleUpgrade(e: Event) {
		const btn = e.target as HTMLButtonElement;
		const plan = btn.dataset.plan as 'pro' | 'proPlus';
		if (!Pricing.prices || !plan) { return; }
		
		const priceId = Pricing.prices[Pricing.billingInterval][plan];
		
		if (!priceId) {
			alert('Price not configured for this selection');
			return;
		}
		
		btn.disabled = true;
		btn.textContent = 'Loading...';
		
		try {
			const res = await fetch('/api/subscription/create-checkout-session', {
				method: 'POST',
				headers: withCsrf({ 'Content-Type': 'application/json' }),
				body: JSON.stringify({ priceId })
			});
			
			const data = await res.json();
				
			if (data.url) {
				window.location.href = data.url;
			} else {
				alert('Failed to start checkout');
				btn.disabled = false;
				btn.textContent = 'Upgrade';
			}
		} catch (err) {
			console.error(err);
			alert('Error starting checkout');
			btn.disabled = false;
			btn.textContent = 'Upgrade';
		}
	}
}
